<template>
  <div>

    <v-stepper elevation="10" class="hidden-sm-and-down" alt-labels v-model="pasoStepper">
      <v-stepper-header>
        <template v-for="(state,stateIndex) in statesTracking">
          <v-stepper-step
              :key="stateIndex"
              color="green"
              :rules="[() => state.value <= pasoStepper && state.valid]"
              error-icon="pending"
              complete-icon="done_all"
              :complete="state.value <= pasoStepper && state.valid"
              :step="state.value"
          >
            <div class="my-6">
              <v-img
                  v-if="state.value === pasoStepper"
                  :max-width=" state.valid ? '100px' : '140px'"
                  :src="state.icon"
                  :alt="state.description"
                  :class="{'mx-4': !state.valid } ">

              </v-img>
              <v-img
                  v-else
                  max-width="60px"
                  class="my-6 mx-4"
                  :src="state.defaultIcon"
              ></v-img>
              <v-chip v-if="state.valid" outlined :color="state.value <= pasoStepper ? '#25ABE3' : 'grey lighten-1'">
                {{ state.description }}
              </v-chip>
              <v-chip v-else outlined color="red lighten-2">
                {{ state.description }}
              </v-chip>
            </div>

          </v-stepper-step>

          <v-divider :style="{'border-color': state.value < pasoStepper ? '#4caf50' : '' }"
                     v-if="state.value <= Object.keys(statesTracking).length -1"
                     :key="state.value"
          ></v-divider>

        </template>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="3">
          <v-chip
              class="ma-2"
              color="green"
              text-color="white"
          >
            <v-avatar
                left
                class="green darken-4"
            >
              {{ tracking.CantidadEntregasPrevias }}
            </v-avatar>
            Entregas previas a la tuya
          </v-chip>


        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-stepper height="70%" width="310px" elevation="10" outlined
               v-model="pasoStepper"
               vertical
               class="hidden-md-and-up v-size--large">
      <template v-for="(state,stateIndex) in statesTracking">
        <v-stepper-step
            :key="stateIndex"
            color="green"
            :rules="[() => state.value <= pasoStepper && state.valid]"
            error-icon="pending"
            complete-icon="done_all"
            :complete="state.value <= pasoStepper && state.valid"
            :step="state.value"
            style="height: 15%"
            class="my-4 ml-10"
            center
        >
          <div>
            <v-img
                v-if="state.value === pasoStepper"
                max-width="110px" :src="state.icon"
               :alt="state.description"
            >

            </v-img>
            <v-img
                v-else
                max-width="60px"
                class="mb-1"
                :src="state.defaultIcon"
                :alt="state.description"
            ></v-img>
            <v-chip v-if="state.value <=4" small outlined style="width: 120px"
                    :color="state.value <= pasoStepper ? '#25ABE3' : ''">
              {{ state.description }}
            </v-chip>
          </div>
        </v-stepper-step>
        <v-stepper-content
            :style="{'border-left': state.value < pasoStepper ? '6px solid #4caf50' : '' }"
            v-if="state.value <= Object.keys(statesTracking).length -1 "
            :key="state.value"
            :step="state.value"
            style="margin-left: 70px"

        >
          <v-chip v-if="state.value ===3"
                            color="green"
                            text-color="white"
                            class="float-sm-left"
                            small
        >
          <v-avatar
              left
              class="green darken-4"
          >
            {{ tracking.CantidadEntregasPrevias }}
          </v-avatar>
          Entregas previas a la tuya
        </v-chip>
          <v-chip v-if="state.value > 4"
                  color="red lighten-3"
                  text-color="white"
                  class="float-sm-left"
                  small
          >

              {{ state.description }}


          </v-chip>

        </v-stepper-content>
        <v-stepper-content
            v-if="state.value > 4"
            :key="state.value"
            :step="state.value"
        >
          <v-chip
              color="red lighten-1"
              text-color="white"
              small
          >
            {{ state.description }}
          </v-chip>

        </v-stepper-content>

      </template>
    </v-stepper>
  </div>
</template>
<script>

import iconPreparacion from '../assets/preparacion.gif'
import iconClasificacion from '../assets/clasificacion.gif'
import iconViajando from '../assets/viajando.gif'
import iconEntregado from '../assets/entregado.gif'
import iconNoEntregado from '../assets/noEntregado.gif'
import iconEntregadoParcial from '../assets/entregadoParcial.gif'
import icon1 from '../assets/pngstates/1.png'
import icon2 from '../assets/pngstates/2.png'
import icon3 from '../assets/pngstates/3.png'
import icon4 from '../assets/pngstates/4.png'

export default {
  name: 'vue-stepper',
  props: {
    tracking: {},
  },
  data() {
    return {
      pasoStepper: 0,
      statesTracking: {
        "EN PLANCHADA": {value: 1, description: 'En preparación', icon: iconPreparacion, defaultIcon: icon1,valid: true},
        "RUTEADO": {value: 2, description: 'En clasificación', icon: iconClasificacion, defaultIcon: icon2,valid: true},
        "DESPACHADO": {value: 3, description: 'En tránsito', icon: iconViajando, defaultIcon: icon3,valid: true},
        "ENTREGADO": {value:4, description: 'Entregado', icon: iconEntregado, defaultIcon: icon4,valid: true},
      }
    }
  },
  created() {
    let stateStart = this.statesTracking[`${this.tracking.Estado.toUpperCase()}`]

    if (!stateStart){
      let statesNot = {
        "NO ENTREGADO": {value: 5, description: 'No pudimos realizar la entrega', icon: iconNoEntregado, valid: false},
        "PARCIAL": {value: 4, description: 'Entrega Parcial', icon: iconEntregadoParcial, valid: false},
      }

      stateStart = statesNot[`${this.tracking.Estado.toUpperCase()}`]
      this.statesTracking['ENTREGADO'] = stateStart

    }
    this.pasoStepper = stateStart.value
  }
}
</script>
<style>
.v-divider {
  border-width: thick 0px 0px;
}

.colordivider {
  border-color: #4caf50;
}
</style>
